import {Component, OnInit, HostListener} from '@angular/core'
import {ReportingService} from '../services/reporting.service'
import {Router} from '@angular/router'
import {GlobalDataService} from '../../housekeeping/services/global-data.service'
import {OwnershipTracking} from "../../owners/models/data-model";

declare var jQuery: any;

@Component({
  selector: 'app-reporting',
  templateUrl: '../views/reporting.component.html',
  styleUrls: []
})
export class ReportingComponent implements OnInit {
  public start = "";
  public end = "";
  public file: any;
  public useriqFile: boolean = true;
  public $j = jQuery.noConflict();
  public userId: any;
  public roleId: any;
  public offset = 0;
  public limit = 10;
  public showAdvance: boolean = false;
  public showAdvanceLink = true;
  public columns: any = [];
  public noData: boolean = false;
  public showBack: boolean = false;
  public showNext: boolean = false;
  public dealerList: any;
  public userList: any = [];
  public selectedUsers: any = [];
  public lastName: string = "";
  public showsubmission: boolean = true;
  public showsubmissionrange: boolean = false;
  public totalRecords = 0;
  p: number;
  public countryList: any = [];
  public countrySelected: any = [];
  public countrySettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'namecode',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public userSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'statusType',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };
  public headerList = ["ID","USER EMAIL","METHOD","VIN","FIRST NAME","LAST NAME","HOME PHONE","MOBILE PHONE","BUSINESS","SALES TYPE","DEALER","PURCHASE DATE"];
  public ownershipTrackingList: any = [];

  constructor(public _reportingService: ReportingService, public _router: Router, public _dataService: GlobalDataService) {
  }

  ngOnInit() {
    this.userId = sessionStorage.getItem('userId');

    if (sessionStorage.getItem('roleId') != "SYSADM" && sessionStorage.getItem('roleId') != "SUSER") {
      console.log(sessionStorage.getItem('roleId'))
      this._router.navigate(['dashboard'])
    }
  }


  onFileSelect(event) {
    if (event.target.files.length > 0) {
      this.file = event.target.files[0];
    }
  }

  onDateSelected(e, dateType) {

    console.log(e.target.value);
    if (dateType == 0) {
      this.start = e.target.value;
    } else {
      this.end = e.target.value;
    }
  }

  onToggleSelected(e,type) {
    if(type == 0){
      this.useriqFile=false;
    }else{
      this.useriqFile=true;
    }
  }
  generateMothlyReport() {
      this._reportingService.postUserIQandInterval(this.file,this.start,this.end,this.useriqFile, result => {
        console.log(result)
      })
  }
  generateTrackingData(){
    this._reportingService.getOwnershipTrackingData(this.start,this.end, (result) => {
      console.log(result)
      this.ownershipTrackingList = result.data;
      this.totalRecords = result.totalRecords;
      if(this.ownershipTrackingList.length == 0){
        this.noData = true;
      }else{
        this.noData = false;
      }
      if(this.totalRecords > this.limit){
        this.showNext = true;
      }else{
        this.showNext = false;
      }
    })

  }

  @HostListener('document:click', ['$event']) clickedOutside() {
    if (this.showAdvance == true) {
      this.showAdvance = false;
      this.showAdvanceLink = true
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/reporting/components/reporting.component.ts